import { Attribute, AttributePropertyValues, IAttribute } from "../System.Runtime/Attribute";
import { NAMESPACE } from "./_Namespace";

export type ClientAwareHelpTextAttributePropertyValues =
    AttributePropertyValues
    & {
        helpText: string;
    };

export type ClientAwareHelpTextAttributeProperties = {
    [name in keyof ClientAwareHelpTextAttributePropertyValues]?: ClientAwareHelpTextAttributePropertyValues[name];
};

export interface IClientAwareHelpTextAttribute extends IAttribute, ClientAwareHelpTextAttributeProperties
{
}

export class ClientAwareHelpTextAttribute extends Attribute implements IClientAwareHelpTextAttribute
{
    public static override classNamespace = NAMESPACE + "ClientAwareHelpTextAttribute";
    public static override className = "ClientAwareHelpTextAttribute";

    public helpText?: string;

    constructor(propertyValues?: Partial<ClientAwareHelpTextAttributePropertyValues>)
    {
        super(propertyValues);

        this.helpText = propertyValues?.helpText;
    }
}